import { render, staticRenderFns } from "./RDialog.vue?vue&type=template&id=4694ec80&"
import script from "./RDialog.vue?vue&type=script&lang=js&"
export * from "./RDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports